import { ComponentTypes, Initiallocations } from "../../../config/config";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { getSiteIdWebUrl } from "../../../services/GraphService";
import { BaseLocationBuilder } from "./BaseLocationBuilder";
import { ILocationBuilder } from "../../../interfaces/ILocationBuilder";

export class SharepointFolderLocationBuilder extends BaseLocationBuilder implements ILocationBuilder {
    constructor(private fileLocationWebUrl: string, private isTeamsFolder: boolean, private siteUrl?: string) {
        super();
    }

    getInitialLocation = (): IPageSettings => {
        const type = this.isTeamsFolder ? ComponentTypes.Teams : ComponentTypes.SharePoint;
        const location = Initiallocations.find(item => item.type === type);

        return {
            type: location.type,
            id: location.id,
            directory: "",
            displayName: location.name,
            webUrl: ""
        }
    }

    async build(siteId: string): Promise<string[]> {
        const siteUrl = this.siteUrl || await this.getSiteWebUrl(siteId);
        const path = this.getPath(siteUrl);
        const paths = path.split("/")
            .filter(value => value)
            .map(this.mapPaths);

        return this.buildPathsToCall(paths);
    }

    private mapPaths = (item: any, index: number) => {
        return index === 0 ? "" : item;
    }

    private async getSiteWebUrl(siteId: string) {
        return await getSiteIdWebUrl(siteId);
    }

    private getPath(siteUrl: string) {
        return this.fileLocationWebUrl.replace(siteUrl, "");
    }
}